import script from "./trCard.vue?vue&type=script&setup=true&lang=js"
export * from "./trCard.vue?vue&type=script&setup=true&lang=js"

import "./trCard.vue?vue&type=style&index=0&id=43ad28b9&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ad28b9"]])

export default __exports__